import React, { useEffect } from 'react'
import Layout from '../../components/common/pageLayout'
import CreateForm from '../../components/FAT/createForm'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import constant from '../../constant'
import { toast } from 'react-toastify'
import { v3_create_fat } from '../../actions/v3/fat'

const Index = (props) => {
    const location = useLocation();
    const { projectId } = location.state;

    const onSubmit = (model) => {
        v3_create_fat(model).then((res) => {
            if (res.status) {
                toast.success(res.result.message)

                props.history.push({
                    pathname: constant.Authedcomponent.fatProject.url,
                    state: {
                        projectId 
                    }
                });
            }
            else {
                toast.error(res.error)
            }
        })
    }

    return (
        <Layout title='FAT'>
            <CreateForm
                onSubmit={onSubmit}
                projectId={projectId}
            />
        </Layout>
    )
}

export default Index